import mollie from "./factories/MolliePaymentGateway";
import "./styles/_main.scss";
host.plugins.register({
    // #region Vars
    name: "288a.payment.mollie",
    // #endregion
    // #region Constructor
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
        host.provider.register('PAYMENT', 'mollie', new mollie());
    },
    // #endregion
});
